import { render, staticRenderFns } from "./InvestmentsGutmannAccount.vue?vue&type=template&id=3407eb8e&scoped=true"
import script from "./InvestmentsGutmannAccount.vue?vue&type=script&lang=js"
export * from "./InvestmentsGutmannAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3407eb8e",
  null
  
)

export default component.exports